<template>
  <div id="dashboard">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg3 sm3 xs12>
          <mini-statistic
            icon="person"
            :title="total.account"
            sub-title="Khách hàng"
            color="primary"
          ></mini-statistic>
        </v-flex>
        <v-flex lg3 sm3 xs12>
          <mini-statistic icon="motorcycle" :title="total.vehicle" sub-title="Xe" color="orange"></mini-statistic>
        </v-flex>
        <v-flex lg3 sm3 xs12>
          <mini-statistic icon="dock" :title="total.device" sub-title="Thiết bị" color="light-blue"></mini-statistic>
        </v-flex>
        <v-flex lg3 sm3 xs12>
          <mini-statistic icon="sim_card" :title="total.sim" sub-title="Simcard" color="green"></mini-statistic>
        </v-flex>
        <v-flex xl12 lg12 sm12 xs12>
          <v-card>
            <v-toolbar card color="white" class="pl-3">
              <h4>Khách hàng mới (trong 30 ngày)</h4>
            </v-toolbar>
            <v-card-text class="pa-0">
              <account-table 
                :isLoading="isLoadingAccount" 
                :datasource="newAccounts && newAccounts.data || []" 
                :total-items="newAccounts && newAccounts.totalRecords"
                @exportFile="openDialogExportFileAcount"
                @changePage="changePageAccount"
                :isFilter="false"
              />
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xl12 lg12 sm12 xs12>
          <v-card>
            <v-toolbar card color="white" class="pl-3">
              <h4>Xe mới (trong 30 ngày)</h4>
            </v-toolbar>
            <v-card-text class="pa-0">
              <vehicle-table 
                ref="vehicleTable"
                :isLoading="isLoadingVehicle" 
                :datasource="newVehicles && newVehicles.data || []" 
                :total-items="newVehicles && newVehicles.totalRecords"
                :isFilter="false"
                @exportFile="openDialogExportFileVehicle"
                @changePage="changePageVehicle"
              />
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xl12 lg12 sm12 xs12>
          <v-card>
            <v-toolbar card color="white" class="pl-3">
              <h4>Hoạt động gần nhất (trong 30 ngày)</h4>
            </v-toolbar>
            <v-card-text class="pa-0">
              <activity-table :isLoading="isLoadingLog" :datasource="logs" />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Dialog xuất file -->
    <dialog-export-file ref="dialogExportFile" :loading="loadingExportFile" @export="handleExportFile"/>
    <!-- Dialog xuất file -->
  </div>
</template>

<script>
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
import Material from 'vuetify/es5/util/colors';
import VWidget from '@/components/VWidget';
import AccountTable from '@/pages/account/components/list';
import VehicleTable from '@/pages/vehicle/components/list';
import ActivityTable from '@/components/activities';
import * as Utils from '@/utils';
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import * as DateTimeFormat from '@/utils/datetime';
import DialogExportFile from '@/components/dialog/DialogExportFile';
import XLSX from 'xlsx';

export default {
  components: {
    AccountTable,
    VehicleTable,
    MiniStatistic,
    VWidget,
    ActivityTable,
    DialogExportFile
  },
  data () {
    return {
      isLoadingAccount: false,
      isLoadingVehicle: false,
      isLoadingLog: false,
      color: Material,
      newVehicles: null,
      newAccounts: null,
      statistics: {},
      logs: [],
      pagination: {
        keySearch: '',
        pageIndex: 1,
        pageSize: 10
      },
      loadingExportFile: false,
      fileName: ''
    };
  },
  computed: {
    ...mapGetters(['loggedUser']),
    total () {
      return {
        account: `${
          this.statistics.account ? this.statistics.account.total : 0
        }`,
        vehicle: `${
          this.statistics.vehicle ? this.statistics.vehicle.total : 0
        }`,
        device: `${this.statistics.device ? this.statistics.device.total : 0}`,
        sim: `${this.statistics.sim ? this.statistics.sim.total : 0}`
      };
    },
    accountType () {
      return [
        {
          value: this.statistics.account.distributor,
          name: 'Nhà phân phối'
        },
        {
          value: this.statistics.account.dealer,
          name: 'Đại lý'
        },
        {
          value: this.statistics.account.normalAccount,
          name: 'Khách hàng'
        }
      ];
    },
    vehicleStatus () {
      return [
        {
          value: this.statistics.vehicle.running,
          name: 'Đang chạy'
        },
        {
          value: this.statistics.vehicle.stopped,
          name: 'Đang dừng'
        },
        {
          value: this.statistics.vehicle.offline,
          name: 'Tắt máy'
        },
        {
          value: this.statistics.vehicle.otherStatus,
          name: 'Khác'
        }
      ];
    },
    deviceActivation () {
      return [
        {
          value: this.statistics.device.activated,
          name: 'Đã kích hoạt'
        },
        {
          value: this.statistics.device.noneActivated,
          name: 'Chưa kích hoạt'
        }
      ];
    },
    simActivation () {
      return [
        {
          value: this.statistics.sim.activated,
          name: 'Đã kích hoạt'
        },
        {
          value: this.statistics.sim.noneActivated,
          name: 'Chưa kích hoạt'
        }
      ];
    }
  },
  mounted () {
    this.isLoadingLog = true;
    this.isLoadingAccount = true;
    this.isLoadingVehicle = true;

    this.getLog({
      accountId: this.loggedUser && this.loggedUser.accountId,
      from: DateTimeFormat.convertDateTimeToSecond2010(
        moment().add(-30, 'days')
      ),
      to: DateTimeFormat.convertDateTimeToSecond2010(moment())
    })
      .then(res => {
        this.logs = res;
        this.isLoadingLog = false;
      })
      .catch(_ => {
        this.isLoadingLog = false;
      });

    this.getNewAccounts(this.pagination).then(res => {
      this.newAccounts = res;
      this.isLoadingAccount = false;
    });

    this.getNewVehicles(this.pagination).then(res => {
      this.newVehicles = res;
      this.isLoadingVehicle = false;
    });

    this.getStatistics().then(res => {
      this.statistics = res;
    });
  },
  methods: {
    ...mapActions([
      'getStatistics',
      'getNewVehicles',
      'getNewAccounts',
      'getLog'
    ]),

    changePageAccount (pagination) {
      this.isLoadingAccount = true;
      this.getNewAccounts(pagination).then(res => {
        this.newAccounts = res;
        this.isLoadingAccount = false;
      });
    },

    changePageVehicle (pagination) {
      console.log('changePageVehicle -> pagination', pagination);
      this.isLoadingVehicle = true;
      this.getNewVehicles(pagination.params).then(res => {
        console.log('changePageVehicle -> res', res);
        this.newVehicles = res;
        this.isLoadingVehicle = false;
      });
    },

    openDialogExportFileVehicle () {
      this.fileName = `Vehicles`;
      let countExportFile = Math.ceil(this.newVehicles.totalRecords / 10000);
      this.$refs.dialogExportFile.open(countExportFile, `New${this.fileName}`);
    },

    openDialogExportFileAcount () {
      this.fileName = `Accounts`;
      let countExportFile = Math.ceil(this.newAccounts.totalRecords / 10000);
      this.$refs.dialogExportFile.open(countExportFile, `New${this.fileName}`);
    },

    async handleExportFile (file) {
      let dataToExport = [];
      switch (this.fileName) {
        case 'Accounts': {
          dataToExport = await this.exportFileAccount(file);
          break;
        }
        case 'Vehicles': {
          dataToExport = await this.exportFileVehicle(file);
          break;
        }
        default: break;
      }
      

      let sheet = XLSX.utils.json_to_sheet(dataToExport);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet, this.fileName);
      XLSX.writeFile(wb, `${file.name}.xlsx`);
    },

    getDateFormatted (value) {
      return this.$refs.vehicleTable.getDateFormatted(value);
    },

    getVehicleStatus (value) {
      return this.$refs.vehicleTable.getVehicleStatus(value);
    },

    async exportFileVehicle (file) {
      let params = {
        keySearch: '',
        pageIndex: file.index,
        pageSize: 10000,
      };

      params[this.typeFilter] = true;

      this.loadingExportFile = true;

      let list = await this.getNewVehicles(params).then(res => {
        return res.data;
      }).catch(err => {
        console.log('exportToExcel -> err', err);
        return [];
      });

      this.loadingExportFile = false;

      let dataToExport = [];
      list.map(item => {
        let vehicle = {
          'Thuộc Khách hàng (Parent)': item.dealerName,
          'Tên khách hàng': item.accountName,
          'Biển số': item.plate,
          'Trạng thái': this.getVehicleStatus(item),
          GPSTime:
            item.stateModel && item.stateModel.time ? item.stateModel.time : 0,
          Imei: item.imei,
          'SĐT Sim': item.simPhone,
          IccId: item.iccId,
          'Ngày kích hoạt': this.getDateFormatted(item.activatedDate),
          'Ngày còn lại': item.remainExpiryDay,
          'Ngày hết hạn': this.getDateFormatted(item.expiryDay),
          'Bị khóa': item.isLocked ? item.isLocked : '',
          'Ngày tạo': this.getDateFormatted(item.createdDate)
        };
        dataToExport.push(vehicle);
        return 0;
      });

      return dataToExport;
    },

    async exportFileAccount (file) {
      let params = {
        keySearch: '',
        pageIndex: file.index,
        pageSize: 10000
      };

      this.loadingExportFile = true;

      let list = await this.getNewAccounts(params).then(res => {
        return res.data || [];
      }).catch(err => {
        console.log('exportToExcel -> err', err);
        return [];
      });

      this.loadingExportFile = false;

      let dataToExport = [];
      list.map(item => {
        let account = {
          'Thuộc Khách hàng (Parent)': item.dealerName,
          'Tên khách hàng': item.name,
          SĐT: item.phone,
          Email: item.email,
          'Số lượng xe': item.vehicle,
          'Số lượng thiết bị': item.device,
          'Số lượng simcard': item.sim,
          'Là Nhà phân phối': item.isDistributor,
          'Là Đại lý': item.isDealer,
          'Ngày tạo': new Date(item.createdDate).toISOString().slice(0, 10),
          'Lần chỉnh sửa cuối': new Date(item.modifiedDate)
            .toISOString()
            .slice(0, 10)
        };
        dataToExport.push(account);
        return 0;
      });
      return dataToExport;   
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/dashboard.vue